import { MapPin, Navigation } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const DoveSiamoSection = () => {
  return <section id="dove-siamo" className="section-padding bg-background">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-section-title text-primary mb-6">
            Come Raggiungere il <span className="text-gold">Ristorante</span>
          </h2>
          <p className="text-body-large text-muted-foreground max-w-2xl mx-auto font-serif">
            Il <strong>ristorante Da Armando</strong> si trova nel cuore di <strong>Passignano sul Trasimeno</strong>, facilmente raggiungibile dall'uscita della superstrada "Passignano Ovest". <strong>Parcheggio gratuito</strong> disponibile per i nostri ospiti.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Map */}
          <div>
            <Card className="card-elegant overflow-hidden cursor-pointer hover:shadow-lg" 
                  onClick={() => {
                    window.open('https://www.google.com/maps/place/Da+Armando/@43.1830392,12.1373984,20.79z/data=!4m20!1m13!4m12!1m4!2m2!1d115.743771!2d-32.2648472!4e1!1m6!1m2!1s0x132c010a0d68782b:0x1f4f23d4a6994ae4!2sVia+Aganoor+Pompili,+25,+06065+Passignano+sul+Trasimeno+PG,+Italia!2m2!1d12.1360188!2d43.1830453!3m5!1s0x132c01a03cf1e8d7:0x4c7a4f5ff1d575cb!8m2!3d43.1831056!4d12.1376995!16s%2Fg%2F11nytyq2vg?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D', '_blank');
                  }}>
              {/* Google Maps Embed */}
              <div className="h-[500px] relative">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.1234567890123!2d12.1376995!3d43.1831056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132c01a03cf1e8d7%3A0x4c7a4f5ff1d575cb!2sDa%20Armando!5e0!3m2!1sit!2sit!4v1234567890123&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Da Armando - Ristorante a Passignano sul Trasimeno"
                  className="rounded-lg pointer-events-none"
                ></iframe>
              </div>
            </Card>
          </div>

          {/* Address and Navigation */}
          <article className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-primary mb-8">Indirizzo Ristorante Passignano sul Trasimeno</h3>
            </div>

            {/* Address Card */}
            <Card className="card-elegant p-6">
              <h4 className="text-xl font-bold text-primary mb-4">Indirizzo</h4>
              <address className="space-y-3 text-muted-foreground not-italic">
                <p className="flex items-center space-x-2">
                  <MapPin size={20} className="text-gold" />
                  <span className="text-lg">Via Aganoor Pompili, 25</span>
                </p>
                <p className="text-lg">06065 Passignano sul Trasimeno (PG)</p>
                <p className="text-lg">Umbria, Italia</p>
              </address>
            </Card>

            {/* Navigation Button */}
            <Card className="card-elegant p-6 cursor-pointer hover:shadow-lg"
                  onClick={() => {
                    window.open('https://www.google.com/maps/place/Da+Armando/@43.1830392,12.1373984,20.79z/data=!4m20!1m13!4m12!1m4!2m2!1d115.743771!2d-32.2648472!4e1!1m6!1m2!1s0x132c010a0d68782b:0x1f4f23d4a6994ae4!2sVia+Aganoor+Pompili,+25,+06065+Passignano+sul+Trasimeno+PG,+Italia!2m2!1d12.1360188!2d43.1830453!3m5!1s0x132c01a03cf1e8d7:0x4c7a4f5ff1d575cb!8m2!3d43.1831056!4d12.1376995!16s%2Fg%2F11nytyq2vg?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D', '_blank');
                  }}>
              <div className="text-center space-y-6">
                <div className="flex justify-center">
                  <Navigation className="text-gold" size={48} />
                </div>
                <div>
                  <h4 className="font-semibold text-primary mb-4">Navigatore per Ristorante</h4>
                  <p className="text-muted-foreground mb-6">
                    Raggiungi facilmente il nostro <strong>ristorante a Passignano sul Trasimeno</strong>. Clicca qui per aprire Google Maps e ottenere le indicazioni stradali in tempo reale dal tuo dispositivo.
                  </p>
                </div>
                <p className="text-gold text-sm">🅿️ Parcheggio gratuito disponibile nei pressi del ristorante</p>
              </div>
            </Card>
          </article>
        </div>
      </div>
    </section>;
};
export default DoveSiamoSection;